export default __webpack_public_path__ + "static/image4-92bf22acd79ce98b73f93d43e3fe8f3c.png";